module.exports = __webpack_public_path__ + "img/rico-eng.8cce0096.png";